<template>
  <div class="main-environment">
    <main>
      <header>
        <h3>环境管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:environment:save')" type="primary" icon="plus" @click="handleOpen('添加')">添加
          </a-button>
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText">
            <a-input-search v-model.trim="pagination.searchText" placeholder="名称/描述"
                            style="width: 200px; " allow-clear :loading="btnLoad" @input="searchTextChange"
                            @search="searchChange" />
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-select v-model="pagination.orgId" placeholder="部门" style="width: 180px;" allowClear
                      :loading="btnLoad" @change="searchChange"   show-search  :filter-option="filterOption">
              <a-select-option  v-for="item in orgList" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :data-source="tableData" :pagination="queryCondition" :loading="tableLoad"
        @change="handleTableChange" :scroll="{ y: 560 }">
        <span slot="action" slot-scope="record"  class="table-action-box">
           <a-tooltip  content="" v-if="$IA('system:environment:update')" title="修改" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
             <a-tooltip  content="" v-if="$IA('system:environment:manageRobot')" title="关联机器人" placement="top" effect="light">
              <i class="table-affiliatedRobots" @click="relationOpen('关联机器人', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:environment:delete')" title="删除" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal centered :title="modalTitle + '环境'" :visible="modalVisible" :confirm-loading="btnLoad"
      @ok="handleOk('addForm')" @cancel="resetForm" :confirmLoading="submitLoad"  :maskClosable="false"  :width="modalTitle == '删除' ? '420px' : '520px'">
      <a-form-model v-if="['添加', '修改'].includes(modalTitle)" layout="vertical" :model="addForm" :rules="addFormRules"
        ref="addForm">
        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="addForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="名称" prop="name">
          <a-input v-model="addForm.name" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="部门" prop="orgId">
            <a-select v-model="addForm.orgId" placeholder="请选择" :disabled="modalTitle == '修改'" show-search  :filter-option="filterOption">
              <a-select-option v-for="v in orgList" :key="v.id" :value="v.id">
              {{ v.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-textarea v-model="addForm.description" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>


      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该环境,是否继续?</p>
      </div>
    </a-modal>

    <!-- 关联机器人摸态框 -->
<!--    <a-modal centered title="关联机器人" :visible="relationRobotVisible" width="600px" @ok="robotSubmit"-->
<!--      @cancel="relationRobotVisible = false" :confirmLoading="submitLoad" :afterClose="emptyTransfer"  :maskClosable="false">-->
<!--      <a-transfer :dataSource="mockData" showSearch :filterOption="filterOption" :targetKeys="targetKeys"-->
<!--        @change="handleChange" @search="handleSearch" @selectChange="handleSelectChange" :selected-keys="selectedKeys"-->
<!--        :render="item => item.title" ref="transfer" :list-style="{-->
<!--          width: '260px',-->
<!--          height: '300px',-->
<!--        }" :titles="['未选', '已选']" />-->

<!--    </a-modal>-->
    <a-modal centered title="关联机器人" :visible="relationRobotVisible" width="630px"  :footer="null"
             @cancel="reResetForm" :confirmLoading="submitLoad" :maskClosable="false">

      <a-form-model :model="relPagination" ref="relPagination" :layout="formLayout" style="margin-bottom: 20px">
        <a-form-model-item prop="searchText">
          <a-input-search v-model.trim="relPagination.searchText" placeholder="机器人"
                          style="width: 200px; " allow-clear :loading="btnLoad" @input="reSearchTextChange"
                          @search="reSearchChange" />
        </a-form-model-item>
        <a-form-model-item prop="type" style="margin-top: -2px;">
          <a-select v-model="relPagination.type" placeholder="类型" style="width: 180px; " allowClear
                    :loading="btnLoad" @change="reSearchChange">
            <a-select-option v-for="(item,index) in this.typeNameList" :value="index">{{ item }}</a-select-option>

          </a-select>
        </a-form-model-item>
      </a-form-model>

      <a-table :columns="reTableColumns" :data-source="reTableData"  :pagination="reQueryCondition" :loading="associationLoad"
               @change="reHandleTableChange"    style="padding-bottom: 20px;"            :row-selection="{onChange: onSelectChange , selectedRowKeys: selectedJobRowKeys, onSelect: handleSelectionChange , onSelectAll: handAllChange}">
        <template slot="type" slot-scope="text">
          <span v-if="text === 0">
            <a-tag color="blue">无人值守</a-tag>
          </span>
          <span v-if="text === 1">
            <a-tag color="cyan">有人值守</a-tag>
          </span>

        </template>
        <template slot="name" slot-scope="text, record">
          <img style="margin: 0 3px 2px 0" :src="statsNameList[record.status]"> {{ record.name }}
        </template>
      </a-table>


    </a-modal>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  computed: {
    // rowEnvironmentSelection() {
    //   return {
    //     onChange: (selectedRowKeys, selectedRows) => {
    //
    //       this.triggerData = selectedRows
    //       this.selectedJobRowKeys = selectedRowKeys;
    //     },
    //     getCheckboxProps: record => ({
    //       props: {
    //         disabled:null, // Column configuration not to be checked
    //       },
    //     }),
    //     selectedRowKeys: this.selectedJobRowKeys,
    //   };
    // },
  },
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      pagination: {
        searchText: '',
        pageSize: 10,
        pageNo: 1,
        orgId:undefined,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
        },
        {
          title: '描述',
          dataIndex: 'description',
          key: 'description',
          ellipsis: true,
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      formLayout:"inline",
      queryCondition:{},
      tableData: [],
      //部门下拉框
      orgList:{},
      // 模态框显隐
      modalVisible: false,
      relationRobotVisible: false,
      // 模态框标题
      modalTitle: '',
      // 单行数据
      singleDta: "",
      // 是否按钮loading
      submitLoad: false,
      // 添加/修改保存API
      saveApi: "",
      // 添加表单
      addForm: {
        id: "",
        name: '',
        orgId:undefined,
        description: ""
      },
      addFormRules: {
        name: [{ required: true, max: 20, message: '环境名称最长不能超过20字符且不可为空' }],
        orgId:[{ required: true, message: '部门不可为空' }],
        description: [{ required: false, max: 250, message: '描述最长不能超过250字符' }]
      },
      // 关联机器人
      mockData: [],
      targetKeys: [],
      relationForm: {
        rids: [], // 机器人id
        environmentId: "", // 环境id
      },
      environmentData: [],
      // 监听获取
      selectedKeys: [],
      // 分页参数
      pagCurrent:{},


      // 关联
      typeNameList:{
        0:'无人值守',
        1:'有人值守',
      },
      relPagination:{
        id:'',
        searchText: '',
        type:undefined,
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: false,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
      },
      // stats名称
      statsNameList: {
       0: require("../assets/images/available.png"),
       1: require("../assets/images/interruptImg.png"),
       2: require("../assets/images/busyImg.png"),
       3: require("../assets/images/norespImg.png"),
      },
      reQueryCondition:{},
      rePagCurrent:'',
      reTableData: [],
      selectedJobRowKeys:[],
      associationLoad:false,
      environmentId:"",
      reTableColumns: [

        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          scopedSlots: { customRender: "name" },
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
          ellipsis: true,
          scopedSlots: { customRender: "type" },
        },
        {
          title: '说明',
          dataIndex: 'description',
          key: 'description',
          ellipsis: true,
        },
      ],
    }
  },
  methods: {
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == '添加' || this.modalTitle == '修改') {
        this.$refs.addForm.resetFields()
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 关联 重置搜索
    reResetForm(){
      this.$refs.relPagination.resetFields();
      this.relationRobotVisible = false;
    },
    // 重置穿梭框方法
    emptyTransfer() {
      const tr = this.$refs.transfer
      if (tr) {
        //左侧搜索框 0
        tr.$children['0'].$children['0']._data.filterValue = ''
        //右侧搜索框 2
        tr.$children['0'].$children['2']._data.filterValue = ''
      }
      this.selectedKeys = []
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title
      this.modalVisible = true
      this.$nextTick(() => {
        this.singleDta = data
        switch (title) {
          case '添加':
            this.saveApi = '/environment/save'
            // this.addForm.orgId = this.$store.state.user.userInfo.orgId
            break;
          case '修改':
            this.saveApi = '/environment/update'
            this.addForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.addForm)
            );
            break;
          case '删除':

            break;
        }
      })
    },
    // 确认模态框
    handleOk(formName) {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.addForm);
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.modalTitle == "添加"? this.pagination:this.pagCurrent);
                  this.resetForm()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitLoad = true;
        this.axios
          .delete("/environment/delete/" + this.singleDta.id)
          .then((res) => {
            this.submitLoad = false;
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange(this.pagCurrent);
              this.modalVisible = false;
            }
          })
          .catch((err) => {
            this.submitLoad = false;
            console.log(err);
          });
      }
    },
    // 打开关联机器人
    relationOpen(title, data) {
      this.relPagination.id = data.id
      this.environmentId  = data.id
      this.reSearchChange()
      this.relationRobotVisible = true
      // const targetKeys = [];
      // const mockData = [];
      // this.environmentData = data
      // this.relationRobotVisible = true;
      // this.axios
      //   .post("/environment/findManageRobot/" + data.id)
      //   .then((res) => {
      //     if (res.code === 200) {
      //       for (let i of res.data) {
      //         let data = {
      //           key: i.id.toString(),
      //           title: i.name,
      //           chosen: i.chosen,
      //         };
      //         if (data.chosen) {
      //           targetKeys.push(data.key);
      //         }
      //         mockData.push(data);
      //       }
      //       this.mockData = mockData
      //       this.targetKeys = targetKeys
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    // 搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(targetKeys, direction, moveKeys) {
      this.relationForm.rids = targetKeys
      this.targetKeys = targetKeys
    },
    handleSearch(dir, value) {
      console.log('search:', dir, value);
    },

    // 单选
    handleSelectionChange(record, selected, selectedRows, nativeEvent){


      // this.associationLoad = true;
      if (selected) {
        var saveData = {
          environmentId: this.environmentId,
          chosen: selected,
          rids: record.id,
        };
      } else {
        var saveData = {
          environmentId: this.environmentId,
          chosen: selected,
          rids: record.id,
        };
      }
      this.robotSubmit(saveData)

    },
    // 全选
    handAllChange(selected, selectedRows, changeRows){
      // this.associationLoad = true;
      let cancelId = [];
      this.reTableData.forEach((v) => {
        cancelId.push(v.id);
      });
      if (selectedRows.length > 0) {
        var selectId = [];
        for (let x of this.reTableData) {
          if (x.chosen) {
            selectId.push(x.id);
          }
        }
        var userSelectId = [];
        userSelectId = this.$lodash.difference(cancelId, selectId);
        var saveData = {
          environmentId: this.environmentId,
          chosen: selected,
          rids: userSelectId.join(","),
        };
      } else {
        var saveData = {
          environmentId: this.environmentId,
          chosen: selected,
          rids: cancelId.join(","),
        };
      }
      this.robotSubmit(saveData)
    },
    onSelectChange(selectedRowKeys){
      this.selectedJobRowKeys = selectedRowKeys;
    },
    // 关联机器人提交
    robotSubmit(saveData) {
      this.axios
          .post("/environment/manageRobot", saveData)
          .then((res) => {
            this.associationLoad = false;
            // console.log(res);
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.reTableAjax();
            }
          })
          .catch((err) => {
            this.associationLoad = false;
            console.log(err);
          });
    },
    // 部门下拉框
    allorgList() {
      this.axios
        .post("/org/findParentOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.orgList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 监听已选中-清空
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    // 关联监听搜索输入框输入
    reSearchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.reSearchChange(val)
      }, 1200);
    },
    // 搜索
    reSearchChange(v) {
      this.reQueryCondition = this.$lodash.cloneDeep(this.relPagination)
      this.reTableAjax()
    },
    // 监听翻页
    reHandleTableChange(pagination, filters, sorter) {
      this.reQueryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.reQueryCondition.current =  pagination.current ? pagination.current : 1
      this.reQueryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.rePagCurrent = pagination ? pagination:this.relPagination
      this.reTableAjax()
    },
    // 翻页请求
    reTableAjax() {
      this.selectedJobRowKeys = []
      this.tableLoad = true
      this.axios.post('/environment/findManageRobot', this.reQueryCondition).then((res) => {
        this.tableLoad = false
        if (res.code === 200) {
          this.reTableData = res.data.records;
          this.reQueryCondition.total = res.data.total;

          let hasChecked = false;
          for (let v of this.reTableData) {
            if (v.chosen) {
              hasChecked = true;
              break;
            }
          }
          if (hasChecked) {
            this.$nextTick(() => {

              for (var i = 0; i < this.reTableData.length; i++) {
                  if (this.reTableData[i].chosen) {
                    this.selectedJobRowKeys.push(i)
                  }
              }
            });
          }



        }
      }).catch((err) => {
        console.log(err);
        this.tableLoad = false
      })
    },


    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true
      this.axios.post('/environment/findPage', this.$qs.stringify(this.queryCondition)).then((res) => {
        this.tableLoad = false
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.queryCondition.total = res.data.total;
        }
      }).catch((err) => {
        console.log(err);
        this.tableLoad = false
      })
    },
  },
  beforeMount() {
    this.searchChange()
    this.allorgList()
  }
}
</script>

<style lang="scss" scoped>
.main-environment {
  .ant-transfer {
    width: 1000px;
  }



  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }


  }


}
</style>